class ExpressService {
    constructor(restangular, localStorageWrapper) {
        this.localStorageWrapper = localStorageWrapper;

        this.api = restangular.one('/Delivery/Express');
    }

    getExpressStoreInfo(addressId, suburbName, postalCode) {
        return this.api.one('StoreInfo').get({ addressId, suburbName, postalCode });
    }

    getExpressDeliveryAddress(shopperId, amasLookUpAddressId) {
        return this.api.one('DeliveryAddress').get({ shopperId, amasLookUpAddressId });
    }

    getExpressManualAddress(shopperId, street1, street2, suburb, postcode) {
        return this.api.one('ManualAddress').get({
            shopperId, street1, street2, suburb, postcode,
        });
    }

    shouldShowExpressSelectedDialog() {
        return this.localStorageWrapper.get('ShowExpressSelectedDialog')
            && this.localStorageWrapper.get('ShowExpressSelectedDialog') === 'show';
    }

    setShowExpressDialogInStorage() {
        this.localStorageWrapper.set('ShowExpressSelectedDialog', 'show');
    }

    setHideExpressDialogInStorage() {
        this.localStorageWrapper.set('ShowExpressSelectedDialog', 'hide');
    }
}

ExpressService.$inject = ['Restangular', 'LocalStorageWrapper'];

module.exports = ExpressService;



// WEBPACK FOOTER //
// ./src/shop/express/express.service.js